<template>
  <div class="login-cover">
    <div class="login-dialog">
      <div class="close-btn" @click="closeDialog">
        <img src="@/assets/images/close-ico.png" alt="" class="close-ico">
      </div>

      <img src="@/assets/images/login-pc.png" alt="" class="login-pc">
      <div class="login-content">
        <div class="login-title">欢迎登录</div>
        <div class="login-tab-list" v-if="!isSkillerPlatform">
          <div class="login-tab-item" :class="activeIndex == 1 ? 'active' : ''" @click="activeIndex = 1">手机登录</div>
          <div class="login-tab-item" :class="activeIndex == 2 ? 'active' : ''" @click="activeIndex = 2">扫码登录</div>
          <div class="login-tab-item" :class="activeIndex == 3 ? 'active' : ''" @click="activeIndex = 3">注册</div>
        </div>
        <div class="login-tab-list"  v-else>
          <div class="login-tab-item" :class="activeIndex == 0 ? 'active' : ''" @click="activeIndex = 0">账号登录</div>
          <!-- <div class="login-tab-item" :class="activeIndex == 1 ? 'active' : ''" @click="activeIndex = 1">手机登录</div>
          <div class="login-tab-item" :class="activeIndex == 3 ? 'active' : ''" @click="activeIndex = 3">注册</div> -->
        </div>
        <!-- <div class=" mt-40px" v-if="isSkillerPlatform">
          <el-form :model="loginParams" ref="ruleFormRef1" :rules="loginAccountFormRefRules" v-if="activeIndex == 0">
            <el-form-item prop="mobile">
              <el-input v-model="loginParams.mobile" placeholder="请输入账号" class="phone-item">
              </el-input>
            </el-form-item>
            <el-form-item prop="passwd">
              <el-input v-model="loginParams.passwd" placeholder="请输入密码" type="password">
              </el-input>
            </el-form-item>
            <el-form-item>
              <div style="display:flex;align-items:center;">


                <el-checkbox v-model="loginParams.agreeTerms">

                </el-checkbox>
                <span style="color: #fff;font-size: 11px;">我已阅读并同意<span class="agreement-link" @click="openUserAgreement('userAgreement')">《用户协议》</span>和<span
                    class="agreement-link" @click="openUserAgreement('privacyPolicies')">《隐私政策》</span></span>
              </div>
            </el-form-item>
            <el-form-item class="submit-item-login">
              <el-button style="width: 100%" type="primary" @click="submitForm(ruleFormRef1)"
                :class="{ 'active': isLoginButtonActive1 }">
                立即登录
              </el-button>
            </el-form-item>
          </el-form>
          <el-form :model="loginParams" ref="ruleFormRef1" :rules="loginFormRefRules" v-else-if="activeIndex == 1">
          </el-form>
        </div>
        <template v-else>  -->
          <div class="login-form" v-if="activeIndex == 0">
          <el-form :model="loginParams" ref="ruleFormRef1" :rules="loginAccountFormRefRules" >
              <el-form-item prop="mobile">
                <el-input v-model="loginParams.mobile" placeholder="请输入账号" class="phone-item">
                </el-input>
              </el-form-item>
              <el-form-item prop="passwd">
                <el-input v-model="loginParams.passwd" placeholder="请输入密码" type="password">
                </el-input>
              </el-form-item>
              <el-form-item>
                <div style="display:flex;align-items:center;">


                  <el-checkbox v-model="loginParams.agreeTerms">

                  </el-checkbox>
                  <span style="color: #fff;font-size: 11px;">我已阅读并同意<span class="agreement-link" @click="openUserAgreement('userAgreement')">《用户协议》</span>和<span
                      class="agreement-link" @click="openUserAgreement('privacyPolicies')">《隐私政策》</span></span>
                </div>
              </el-form-item>
              <el-form-item class="submit-item-login">
                <el-button style="width: 100%" type="primary" @click="submitForm(ruleFormRef1)"
                  :class="{ 'active': isLoginButtonActive1 }">
                  立即登录
                </el-button>
              </el-form-item>
            </el-form>
          </div>
          <div class="login-form" v-else-if="activeIndex == 1">
            <el-form :model="loginParams" ref="ruleFormRef" :rules="loginFormRefRules">
              <el-form-item prop="phone">
                <el-input v-model="loginParams.phone" placeholder="请输入手机号" class="phone-item">
                  <template #prefix>
                    <div class="prefix-phone">
                      +86 &nbsp; <span class="spilt-line">|</span>
                    </div>
                  </template>
                </el-input>
              </el-form-item>
              <el-form-item prop="code">
                <el-input v-model="loginParams.code" placeholder="请输入验证码">
                  <template #suffix>
                    <div class="suffix-code" @click="getCode"
                      :class="{ 'disabled': isDisabled, 'active': loginParams.phone }">{{ codeText }} {{ isDisabled ?
                        '秒后重试' : '' }}
                    </div>
                  </template>
                </el-input>
              </el-form-item>
              <el-form-item>
                <div style="display:flex;align-items:center;">


                  <el-checkbox v-model="loginParams.agreeTerms">

                  </el-checkbox>
                  <span style="color: #fff;font-size: 11px;">我已阅读并同意<span class="agreement-link" @click="openUserAgreement('userAgreement')">《用户协议》</span>和<span
                      class="agreement-link" @click="openUserAgreement('privacyPolicies')">《隐私政策》</span></span>
                </div>
              </el-form-item>
              <el-form-item class="submit-item-login">
                <el-button style="width: 100%" type="primary" @click="submitForm(ruleFormRef)"
                  :class="{ 'active': isLoginButtonActive }">
                  立即登录
                </el-button>
              </el-form-item>
            </el-form>
          </div>
          <div class="code-login-form" v-else-if="activeIndex == 2">
            <div class="qr-code">
              <img :src="QRImgUrl" alt="" class="qr-code-img">
              <!-- <div class="qr-code-tip">Z视介 App 扫码登录</div> -->
              <div class="qr-code-tip">
                <span style="color: #fff;font-size: 11px;">登录即代表同意<span class="agreement-link">《用户协议》</span>和<span
                    class="agreement-link">《隐私政策》</span></span>

              </div>

            </div>
          </div>
          <div class="register-form" v-else-if="activeIndex == 3">
          <el-form ref="registerFormRef" :model="registerParams" :rules="registerFormRefRules" label-width="auto"
            class="demo-ruleForm">
            <el-form-item>
              <el-input v-model="registerParams.name" placeholder="请输入用户昵称" />
            </el-form-item>
            <el-form-item prop="phone">
              <el-input v-model="registerParams.phone" placeholder="请输入手机号" class="phone-item">
                <template #prefix>
                  <div class="prefix-phone">
                    +86
                  </div>
                </template>
              </el-input>
            </el-form-item>
            <el-form-item prop="passWord">
              <el-input v-model="registerParams.passWord" placeholder="请输入密码" type="password" />
            </el-form-item>
            <el-form-item prop="passWord1">
              <el-input v-model="registerParams.passWord1" placeholder="请确认密码" type="password" />
            </el-form-item>
            <el-form-item prop="code">
              <el-input v-model="registerParams.code" placeholder="请输入验证码">
                <template #suffix>
                  <div class="suffix-code" @click="getCode" :class="isDisabled ? 'disabled' : ''">{{ codeText }}</div>
                </template>
              </el-input>
            </el-form-item>
            <el-form-item class="submit-item">
              <el-button style="width: 100%" type="primary" @click="submitRegisterForm(registerFormRef)">
                注册
              </el-button>
            </el-form-item>

          </el-form>
        </div>
      </div>
    </div>
  </div>

  <!-- 用户协议确认弹窗 -->
  <div v-if="showAgreementDialog" class="agreement-cover">
    <div class="agreement-dialog">
      <div class="close-btn" @click="closeAgreementDialog">
        <img src="@/assets/images/close-ico.png" alt="" class="close-ico">
      </div>

      <div class="agreement-content">
        <div class="agreement-title">用户协议与隐私保护</div>
        <div class="agreement-text">
          <span>我已阅读并同意<span class="agreement-link" @click="openUserAgreement('userAgreement')">《用户协议》</span>与<span class="agreement-link" @click="openUserAgreement('privacyPolicies')">《隐私政策》</span></span>
        </div>
        <div class="agreement-buttons">
          <el-button @click="closeAgreementDialog" class="cancel-btn" >取消</el-button>
          <el-button @click="agreeAndLogin" type="primary" class="agree-btn">同意并登录</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { reactive, ref, watch, onMounted, onBeforeUnmount } from "vue";
import type { FormInstance, FormRules } from "element-plus";
import { ElMessage } from "element-plus";
import { ApiUser } from "@/api/login";
import useUserStore from "@/stores/user";
import QRCode from "qrcode";
import { Base64 } from "js-base64";
import {
  sortAndEncrypt,
  getUniqueDeviceIdentifier,
  setToken,
  removeToken,
} from "@/utils/login";
import { useRoute, useRouter } from "vue-router";
import { refreshPage } from "@/utils/systemUtils";

// 登录表单接口定义
interface loginForm {
  phone: string;
  code: string;
  agreeTerms: boolean;
}

declare global {
  interface Window {
    TencentCaptcha: any;
  }
}

const router = useRouter();
const route = useRoute();
const userStore = useUserStore();
const activeIndex = ref(1)
const isSkillerPlatform = computed(() => route.path === "/skillerPlatform");
const ruleFormRef = ref<FormInstance>();
const ruleFormRef1 = ref<FormInstance>();
const registerFormRef = ref<FormInstance>();
const codeText = ref<any>("获取验证码");
const timer = ref<any>(null);
const isDisabled = ref<boolean>(false);
const isLoginButtonActive = ref<boolean>(false);
const isLoginButtonActive1 = ref<boolean>(false);
//二维码登录
const QRImgUrl = ref<string>("");
const QRcode = ref<string>("");
const timerQr = ref<any>(null);
// 用户协议确认弹窗
const showAgreementDialog = ref<boolean>(false);

const loginParams = reactive<loginForm>({
  phone: "",
  code: "",
  agreeTerms: false,
});

watch(() => ({ phone: loginParams.phone, code: loginParams.code }), (newVal) => {
  // 判断phone和code是否都不为空
  if (newVal.phone && newVal.code) {
    isLoginButtonActive.value = true;
  } else {
    isLoginButtonActive.value = false;
  }
}, { deep: true });
watch(() => ({ mobile: loginParams.mobile, passwd: loginParams.passwd }), (newVal) => {
  // 判断phone和code是否都不为空
  if (newVal.mobile && newVal.passwd) {
    isLoginButtonActive1.value = true;
  } else {
    isLoginButtonActive1.value = false;
  }
}, { deep: true });



const registerParams = reactive({
  phone: "",
  code: "",
  name: "",
  passWord: "",
  passWord1: "",
});
const captcha = ref<any>("");
const loginAccountFormRefRules = reactive<FormRules<loginForm>>({
  phone: [
    {
      required: true,
      message: "请输入账号",
      trigger: "blur",
    },
  ],
  passwd: [
    {
      required: true,
      message: "请输入密码",
      trigger: "blur",
    },
  ],
});
const loginFormRefRules = reactive<FormRules<loginForm>>({
  phone: [
    {
      required: true,
      message: "请输入手机号",
      trigger: "blur",
    },
    {
      pattern: /^1[3-9]\d{9}$/, // 简单的中国大陆手机号正则表达式
      message: "请输入正确的手机号",
      trigger: "blur",
    },
  ],
  code: [
    {
      required: true,
      message: "请输入验证码",
      trigger: "change",
    },
  ],
});
const registerFormRefRules = reactive({
  phone: [
    {
      required: true,
      message: "请输入手机号",
      trigger: "blur",
    },
    {
      pattern: /^1[3-9]\d{9}$/, // 简单的中国大陆手机号正则表达式
      message: "请输入正确的手机号",
      trigger: "blur",
    },
  ],
  passWord: [
    {
      required: true,
      message: "请输入密码",
      trigger: "change",
    },
    {
      validator: (rule, value, callback) => {
        // 验证密码长度和复杂度
        if (
          !value ||
          !/^(?=.*[0-9])(?=.*[a-zA-Z])(?=.*[^a-zA-Z0-9]).{6,20}$/.test(value)
        ) {
          callback(new Error("密码需要6-20位数字、字母、特殊符号组合"));
        } else {
          callback();
        }
      },
      trigger: "blur",
    },
  ],
  passWord1: [
    {
      required: true,
      message: "请确认密码",
      trigger: "change",
    },
    {
      validator: (rule, value, callback) => {
        // 假设this.form是您的表单数据对象
        if (value !== registerParams.passWord) {
          callback(new Error("两次输入的密码不一致!"));
        } else {
          callback();
        }
      },
      trigger: "blur",
    },
  ],
  code: [
    {
      required: true,
      message: "请输入验证码",
      trigger: "change",
    },
  ],
});

// 定义验证码js加载错误处理函数
const loadErrorCallback = () => {
  var appid = "2052530371";
  // 生成容灾票据或自行做其它处理
  var ticket =
    "terror_1001_" + appid + "_" + Math.floor(new Date().getTime() / 1000);
  callback({
    ret: 0,
    randstr: "@" + Math.random().toString(36).substr(2),
    ticket: ticket,
    errorCode: 1001,
    errorMessage: "jsload_error",
  });
};


const submitForm = async (formEl: FormInstance | undefined) => {
  if (!formEl) return;

  // 检查是否同意用户协议
  if (!loginParams.agreeTerms) {
    showAgreementDialog.value = true;
    return;
  }
  console.log("submit!", loginParams);
  await formEl.validate((valid, fields) => {
    if (valid) {
      if (isSkillerPlatform.value) {
        executeLogin1();
      }else{ 
        executeLogin();
      }
      
    } else {
      console.log("error submit!", fields);
    }
  });
};

// 执行登录逻辑
const executeLogin = () => {
  
    let obj = {
      // appId: 1000,
      sourceId: 0, 
      mobile: loginParams.phone, //手机号
      verifyCode: loginParams.code, //手机验证码
      deviceId: getUniqueDeviceIdentifier(), //设备id
      sceneId: "1", //场景id或活动id
      sceneType: "scene_ai", //场景类型
      sceneName: "AI工具集", //场景名称
    };
    ApiUser.loginPhoneApi(sortAndEncrypt(obj))
      .then((res: any) => {
        if (res.code == 200) {
          console.log(res);
          setToken(res.data.sessionId);
          userStore.setup();
          ElMessage.success("登录成功");
          refreshPage(router)
        } else {
          ElMessage.error(res.msg);
        }
      })

  
};
// 执行登录逻辑
const executeLogin1 = () => {
  
  let obj = {
    appId: 1000,
    // mobile: loginParams.mobile, //手机号
    
    // verifyCode: loginParams.code, //手机验证码
    deviceId: getUniqueDeviceIdentifier(), //设备id
    sceneId: "1", //场景id或活动id
    sceneType: "scene_ai", //场景类型
    sceneName: "AI工具集", //场景名称
  };
  if(activeIndex.value == 0){
    obj.mobile = loginParams.mobile
    obj.passwd = loginParams.passwd
  }else if(activeIndex.value == 1){
    obj.mobile = loginParams.phone
    obj.verifyCode = loginParams.code
  }
    ApiUser.loginPhoneApiWapLogin(sortAndEncrypt(obj))
      .then((res: any) => {
        if (res.code == 200) {
          setToken(res.data.sessionId);
          userStore.setup();
          ElMessage.success("登录成功");
          userStore.dialogLogin = false;
          // refreshPage(router)
        } else {
          ElMessage.error(res.msg);
        }
      })

  
};

const closeDialog = () => {
  userStore.dialogLogin = false;
};

// 关闭协议确认弹窗
const closeAgreementDialog = () => {
  showAgreementDialog.value = false;
};

// 同意协议并登录
const agreeAndLogin = async () => {
  loginParams.agreeTerms = true;
  showAgreementDialog.value = false;

  // 执行表单验证和登录
  if (!isSkillerPlatform.value) {
    await ruleFormRef.value.validate((valid) => {
      if (valid) {
        executeLogin();
      }
    });
  }else if(isSkillerPlatform.value){
    await ruleFormRef1.value.validate((valid) => {
      if (valid) {
        executeLogin1();
      }
    });
  }
};

// 打开用户协议页面
const openUserAgreement = (type: string = 'userAgreement') => {
  const resolvedRoute = router.resolve({ path: '/userAgreement', query: { type } });
  window.open(resolvedRoute.href, '_blank');
};

const getCode = () => {
  if (isDisabled.value) return;

  try {
    let reg =
      /^(13[0-9]|14[0-9]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[0-9])\d{8}$/;
    if (activeIndex.value == 1) {
      if (loginParams.phone != "" && reg.test(loginParams.phone)) {
        captcha.value.show();
      } else {
        ElMessage.error("请填写正确的手机号。");
      }

    }
    else if (activeIndex.value == 3) {
      if (registerParams.phone != "" && reg.test(registerParams.phone)) {
        captcha.value.show();
      } else {
        ElMessage.error("请填写正确的手机号。");
      }
    }

  } catch (error) {
    loadErrorCallback();
  }
};
const beginTime = () => {
  isDisabled.value = true;
  codeText.value = 60;
  if (timer.value) {
    clearInterval(timer.value);
  }
  timer.value = setInterval(() => {
    if (codeText.value > 0) {
      codeText.value--;
    } else {
      endTime();
    }
  }, 1000); // 每秒执行一次
};
const endTime = () => {
  if (timer.value) {
    clearInterval(timer.value);
    timer.value = null;
    isDisabled.value = false; // 可以在这里重新启用操作
    codeText.value = "获取验证码"; // 或者设置回初始状态
  }
};
// 定义回调函数
const callback = (res: any) => {
  console.log("callback:", res);
  beginTime();
  if (res.ret === 0) {
    let obj = {
      ticket: res.ticket, //票据
      randstr: res.randstr, //随机数
      sourceId: 0, //产品id 0 z视介， 1 蓝新闻， 默认0
      mobile: activeIndex.value == 1 ? loginParams.phone : registerParams.phone, //手机号
      // mobile: loginParams.phone, //手机号
      code: "+86", //国家编号，大陆 +86
    };
    try {
      ApiUser.sendCodeApi(sortAndEncrypt(obj))
        .then((res) => {
          console.log(res);
          if (res.code == 200) {
            console.log("请求成功");
          } else {
            ElMessage.error(res.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    } catch (error) {
      console.log(error);
    }
  }
};
const submitRegisterForm = async (formEl: FormInstance | undefined) => {
  if (!formEl) return;
  await formEl.validate((valid, fields) => {
    if (valid) {
      let obj = {
        appId: 1000,
        mobile: registerParams.phone, //手机号
        passwd: registerParams.passWord, //用户密码
        nickName: registerParams.name, //用户昵称
        verifyCode: registerParams.code, //手机验证码
        deviceId: getUniqueDeviceIdentifier(), //设备id
        sceneId: "1", //场景id或活动id
        sceneType: "scene_ai", //场景类型
        sceneName: "AI工具集", //场景名称
      };
      ApiUser.registerAccountApi(sortAndEncrypt(obj))
        .then((res: any) => {
          console.log(res);
          if (res.code == "200") {
            ElMessage.success("注册成功");
            activeIndex.value = 1; // 切换到手机登录
          } else {
            ElMessage.error(res.msg);
          }
        })
        .catch((err: any) => {
          console.log(err);
        });
    } else {
      console.log("error submit!", fields);
    }
  });
};
const getQrCode = () => {
  ApiUser.getQrCode()
    .then((res) => {
      let scanInfo = {
        type: "login",
        platForm: Base64.encode("AI工具集"),
        code: res.data.qrCode,
      };
      QRcode.value = res.data.qrCode;
      let QRlinkValue =
        "https://ztv.cztv.com/ap/download/index.shtml?nbtvscaninfo=" +
        Base64.encode(JSON.stringify(scanInfo));
      QRCode.toDataURL(
        QRlinkValue,
        { errorCorrectionLevel: "L", margin: 2, width: 128 },
        (err: any, url: any) => {
          if (err) throw err;
          QRImgUrl.value = url;
        }
      );
    })
    .catch((err) => {
      console.log(err);
    });
};

// const switchLoginType = () => {
//   if (loginType.value == 1) {

//   } else {
//     clearInterval(timerQr.value);
//   }
// };
watch(activeIndex, (val) => {
  // clearInterval(timer.value);
  if (val == 2) {
    getQrCode();
    if (timerQr.value) {
      clearInterval(timerQr.value);
    }
    timerQr.value = setInterval(() => {
      ifQrLogin();
    }, 2000);
  } else {
    clearInterval(timerQr.value);
  }
});

const ifQrLogin = () => {
  let obj = {
    qrCode: QRcode.value,
  };
  ApiUser.checkQrcode(sortAndEncrypt(obj))
    .then((res: any) => {
      if (res.code == "200") {
        clearInterval(timerQr.value);
        setToken(res.data.sessionId);
        // let detaT = {
        //   groupId: import.meta.env.MODE === "production" ? 5 : 35,
        // };
        // ApiUser.authenticationUser(sortAndEncrypt(detaT)).then((res) => {
        // if (res.data.exists) {
        userStore.setup();
        ElMessage.success("登录成功");
        userStore.dialogLogin = false;
        // } else {
        //   ElMessage.warning("智媒果AI平台暂仅限广电集团内部员工使用");
        //   userStore.logout();
        //   removeToken();
        //   userStore.dialogLogin = false;
        // }
        // });
      }
    })
    .catch((err) => {
      // console.log(err)
    });
};
watch(isSkillerPlatform, (val) => {
  if(val){
    activeIndex.value = 0;
  }else{
    activeIndex.value = 1;
  }
}, { immediate: true });

onMounted(() => {
  captcha.value = new TencentCaptcha("2052530371", callback, {});
  // if(isSkillerPlatform.value){
  //   activeIndex.value = 0;
  // }else{
  //   activeIndex.value = 1;
  // }
});
onBeforeUnmount(() => {
  endTime();
  clearInterval(timerQr.value);
});

</script>

<style scoped lang="scss">
.login-cover {
  background: rgba(0, 0, 0, 0.7);
  backdrop-filter: blur(8px);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 900;
  display: flex;
  justify-content: center;
  align-items: center;

  .login-dialog {
    /* width: 538px; */
    min-height: 330px;
    background: rgb(19, 22, 34);
    border-radius: 10px;
    border: 1px solid rgba(255, 255, 255, 0.1);
    backdrop-filter: blur(10px);
    display: flex;

    .close-btn {
      position: absolute;
      top: 22px;
      right: 15px;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 1;
      width: 25px;
      height: 25px;

      .close-ico {
        width: 14px;
        height: 14px;
      }
    }

    .login-pc {
      width: 210px;
      border-radius: 0 0 10px 10px;
      font-weight: 600;
      font-size: 18px;
      color: #FFFFFF;
    }

    .login-content {
      padding: 24px 21px;
      /* width: 100%; */
      width: 333.3px;
      min-height: 100%;
      background-color: rgb(19, 22, 34);
      height: fit-content;
      border-radius: 0 10px 10px 0;

      /* display: flex;
       flex-direction: column; */
      /* border: 1px solid rgba(255, 255, 255, 0.1); */
      .login-title {
        font-weight: 600;
        font-size: 18px;
        color: #FFFFFF;
      }

      .login-tab-list {
        display: flex;
        gap: 24px;
        margin-top: 30px;

        .login-tab-item {
          cursor: pointer;
          font-weight: 500;
          font-size: $smallTitleSize;
          color: rgba(255, 255, 255, 0.7);

          &.active {
           
            background: linear-gradient(45deg, #00DCFF 0%, #005DFF 100%);
            background-clip: text;

          }

          &.active::after {
            content: '';
            display: block;
            width: 100%;
            height: 2px;
            background: linear-gradient(45deg, #00DCFF 0%, #005DFF 100%);
            margin-top: 5px;
          }
        }
      }

      .login-form,
      .register-form {
        margin-top: 20px;
      }

      .code-login-form {
        margin-top: 33px;
        width: 100%;

        .qr-code {

          display: flex;
          justify-content: center;
          flex-direction: column;
          align-items: center;

          .qr-code-img {
            width: 116px;
            height: 116px;
            border-radius: 8px;
          }

          .qr-code-tip {
            margin-top: 35px;

          }
        }
      }
    }
  }
}

.el-form-item {
  width: 288px;

  :deep {
    .el-form-item__error {
      font-size: $textSize;
      top: 106%;
    }

    .el-input__wrapper {
      background: #0D1117;
      border-radius: 8px;
      box-shadow: 0 0 0 1px rgba(255, 255, 255, 0.1) inset;
      transition: all 0.3s;

      &:hover {
        box-shadow: 0 0 0 1px rgba(0, 174, 255, 0.20) inset !important;
      }
    }

    .el-input__inner {
      font-size: $textSize;
      color: #FFFFFF;
    }

    .el-input__inner::placeholder {
      color: rgba(255, 255, 255, 0.4);
      font-size: 13px;
      font-weight: 400 !important;
    }

    .el-button {
      background: #323A45;
      color: rgba(255, 255, 255, 0.4);
      border: none;
      border-radius: 14px;
      height: 36px;
      font-size: $tipSize;

      &.active {
        background: linear-gradient(135deg, #0028FF 0%, #2800FF 53%, #00C3FF 100%);
        color: #fff;
      }
    }

    .el-checkbox {
      margin-right: 5px;
    }
  }

  .prefix-phone {
    color: #FFFFFF;
    font-size: 11px;

    .spilt-line {
      color: rgba(255, 255, 255, 0.08);
    }
  }

  .suffix-code {
    cursor: pointer;
    font-size: $textSize;

    &.active {
      color: rgba(0, 174, 255, 1);
    }

    /* color: #409EFF; */
    &.disabled {
      color: rgba(0, 174, 255, 0.6);
    }
  }
}

.submit-item-login {
  margin-bottom: 0;
  height: 36px;
  margin-top: 10px;
}

.submit-item {
  margin-bottom: 0;
  height: 36px;
  margin-top: 30px;
}

// 协议链接样式
.agreement-link {
  color: #00AEEF;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
}

// 用户协议确认弹窗样式
.agreement-cover {
  background: rgba(0, 0, 0, 0.7);
  backdrop-filter: blur(8px);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 950;
  display: flex;
  justify-content: center;
  align-items: center;

  .agreement-dialog {
    width: 420px;
    background: rgb(19, 22, 34);
    border-radius: 10px;
    border: 1px solid rgba(255, 255, 255, 0.1);
    backdrop-filter: blur(10px);
    position: relative;

    .close-btn {
      position: absolute;
      top: 22px;
      right: 15px;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 1;
      width: 25px;
      height: 25px;

      .close-ico {
        width: 14px;
        height: 14px;
      }
    }

    .agreement-content {
      padding: 24px;

      .agreement-title {
        font-weight: 600;
        font-size: 18px;
        color: #FFFFFF;
      }

      .agreement-text {
        font-weight: 500;
        font-size: 17px;
        color: #FFFFFF;
        padding-top: 50px;
        padding-bottom: 60px;
      }

      .agreement-buttons {
        display: flex;
        gap: 16px;
        justify-content: center;
        color: #fff;
        .cancel-btn {
          background: #323A45;
          width: 92px;
          height: 32px;
          border-radius: 16px;
        }

        .agree-btn {
          width: 92px;
          height: 32px;
          background: linear-gradient(135deg, #0028FF 0%, #2800FF 53%, #00C3FF 100%);
          border-radius: 16px;
        }
      }
    }
  }
}
</style>
